import { doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { auth, db } from "../firebase";

export default function useGetMessages() {

    const [messages, setMessages] = useState([])

    useEffect(() => {

        if(!auth.currentUser) return () => null

        const unsubscribe = onSnapshot(doc(db, "messages", auth.currentUser.uid), {
            next: snap => {

                if(snap.exists()) {
                    setMessages(snap.data().messages)
                }

            },
            error: err => console.log(err)
        })
        
        
        return unsubscribe

    }, [])

    useEffect(() => {

        if(!auth.currentUser) return () => null

        let chats = [ ]
        let changes = 0
        for(const chat of messages) {

            if(chat.sender !== auth.currentUser.uid) {
                if(!chat.read) {
                    let newChat = { ...chat, read: true }
                    chats.push(newChat)
                    changes++
                    continue
                }
            }

            chats.push(chat)

        }

        if(changes > 0) {
            updateDoc(doc(db, "messages", auth.currentUser.uid), {
                messages: chats
            })
            changes = 0
        }

    }, [messages])

    return messages

}

export async function sendMessage(message) {
    
    try {

        
        let messages = (await getDoc(doc(db, "messages", auth.currentUser.uid)))
        
        if(!messages.exists()) {
            
            setDoc(doc(db, "messages", auth.currentUser.uid), {
                messages: [
                    {
                        message,
                        sentAt: new Date().toISOString(),
                        _id: new Date().toISOString(),
                        sender: auth.currentUser.uid
                    }
                ]
            }) 
            return
        }

        setDoc(doc(db, "messages", auth.currentUser.uid), {
            messages: [
                ...messages.data().messages,
                {
                    message,
                    sentAt: new Date().toISOString(),
                    _id: new Date().toISOString(),
                    sender: auth.currentUser.uid
                }
            ]
        }) 
        
        updateDoc(doc(db, "clients", auth.currentUser.uid), {
            sender: "client",
            message,
            sentAt: new Date().toISOString(),
        })

    } catch(err) { console.log(err)}

}